import { render, staticRenderFns } from "./PartesAereo.vue?vue&type=template&id=6ac662b0&"
import script from "./PartesAereo.vue?vue&type=script&lang=js&"
export * from "./PartesAereo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports